module.exports = __webpack_public_path__ + "img/HKG.425bf8d.svg";